import { useEffect, useMemo, useState } from 'react';

import { EllipsisVertical } from 'lucide-react';
import { Select, DefaultTooltip, ToggleOptionGroup, ToggleOptionGroupItem } from 'twyne-new.ui'

import { useCraftProp } from '@/components/builder/utils';
import { useResponsive, useUtilities } from '@/modules/cms/views/post/components/builder/context';

import PositionInputs from './components/PositionInputs';

export default function PositionProperty() {
  const { device } = useResponsive()
  const { utilitiesParsed } = useUtilities()

  return <Position key={device + utilitiesParsed} />
}

const Position = () => {
  const { value, setValue } = useCraftProp('position.value')
  const { value: bottom, setValue: setBottom } = useCraftProp('position.bottom')
  const { value: left, setValue: setLeft } = useCraftProp('position.left')
  const { value: right, setValue: setRight } = useCraftProp('position.right')
  const { value: top, setValue: setTop } = useCraftProp('position.top')
  const [showInputs, setShowInputs] = useState()

  const positionValues = useMemo(() => bottom || left || right || top, [bottom, left, right, top])
  const setters = useMemo(() => ({ bottom: setBottom, left: setLeft, right: setRight, top: setTop }), [setBottom, setLeft, setRight, setTop])
  const canShowInputs = useMemo(() => value && value !== 'static', [value])

  useEffect(() => {
    if (showInputs === undefined) {
      setShowInputs(canShowInputs && positionValues)
    }
  }, [showInputs, canShowInputs, positionValues])

  return <>
    <div className='flex flex-col gap-1'>
      <div className='flex gap-1'>
        <Select
          value={value}
          onChange={option => setValue(option?.value)}
          options={POSITION_OPTIONS}
          clearable
          variant='accent'
        />
        {canShowInputs && <ToggleOptionGroup size='lg' value={showInputs ? 'show' : ''} type='single' onValueChange={() => setShowInputs(!showInputs)}>
          <ToggleOptionGroupItem value='show'>
            <DefaultTooltip size='left' content={showInputs ? 'Hide position inputs' : 'Show position inputs'} triggerProps={{ className: 'w-full flex justify-center' }}>
              <EllipsisVertical size='14' />
            </DefaultTooltip>
          </ToggleOptionGroupItem>
        </ToggleOptionGroup>}
      </div>

      {showInputs && canShowInputs ? <>
        <PositionInputs
          values={{ bottom, left, right, top }}
          onChange={({ item, value }) => setters[item](value)}
        />
      </> : null}
    </div>
  </>
}

const POSITION_OPTIONS = [
  { label: 'Static', value: 'static' },
  { label: 'Relative', value: 'relative' },
  { label: 'Absolute', value: 'absolute' },
  { label: 'Fixed', value: 'fixed' },
  { label: 'Sticky', value: 'sticky' },
]
